import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import { Row, Col } from 'react-bootstrap'
import { formValueSelector, reduxForm } from 'redux-form'
import { EntityAutocomplete } from '../../../../Forms/SharedComponents/containers'
import { obtenerTransferenciasExportadores } from '../../../actions/listados'
import TransferenciasExportadoresView from '../../../components/listados/movimientosExportadores/TransferenciasExportadoresView'
import { FORM_TRANSFERENCIAS_EXPORTADOR } from '../../../../../config/forms'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../config/settings'

function TransferenciasEntreExportadores (props) {
  const { obtenerTransferenciasExportadores, exportador, change: formChange } = props
  const [show, setShow] = useState(false)

  const handleSubmit = (all = false) => {
    if (all) { formChange('exportador', null) }
    formChange('exportadorBusqueda', exportador)
    setShow(true)
    obtenerTransferenciasExportadores(exportador)
  }

  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <h3 style={{ marginBottom: '2%' }}>Transferencias entre exportadores</h3>
      <Row style={{ alignItems: 'center', justifyContent: 'center' }}>
        <Col md={4}>
          <EntityAutocomplete
            name='exportador'
            label='Seleccione el exportador de origen'
            entity='exportador'
            placeholder='Exportador - 19999999991'
            value={''}
          />
        </Col>
        <Col md={3}>
          <Button
            onClick={handleSubmit}
            size='small'
            variant='contained'
            color='primary'
            disabled={!exportador}
            style={{ outline: 'none' }}
          >
                        Consultar
          </Button>
        </Col>
        <Col md={3}>
          <Button
            onClick={() => { handleSubmit(true) }}
            size='small'
            variant='contained'
            color='primary'
            style={{ outline: 'none' }}
          >
                        Listado completo de transferencias
          </Button>
        </Col>
      </Row>
      { show && <TransferenciasExportadoresView /> }
    </>
  )
}

const selector = formValueSelector(FORM_TRANSFERENCIAS_EXPORTADOR)

const mapStateToProps = (state) => ({
  exportador: selector(state, 'exportador')
})
const mapActionsToProps = {
  obtenerTransferenciasExportadores
}

const withReduxForm = reduxForm({
  form: FORM_TRANSFERENCIAS_EXPORTADOR
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(TransferenciasEntreExportadores))
